<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'baseList' }">基地列表</el-breadcrumb-item>
        <el-breadcrumb-item>生产数据维护</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="基地名称：">
              <el-select clearable style="width: 100%" size="small" v-model="listParams.farmId" placeholder="请选择基地">
                <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="farmId" align="center" label="id"> </el-table-column>

        <el-table-column prop="farmTitle" align="center" label="基地名称"> </el-table-column>

        <el-table-column prop="addressAccount" align="center" label="种植位置数量"> </el-table-column>

        <el-table-column prop="measureTotal" align="center" label="总亩数"> </el-table-column>

        <el-table-column prop="areaTitle" align="center" label="种植位置(个)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.areaTitleList" :key="index">
              <span>{{ item.areaTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="measure" align="center" label="亩数(亩)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.areaTitleList" :key="index">
              <span>{{ item.measure }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.areaTitleList" :key="index">
              <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(item.areaId)">
                <span>删除</span>
              </confirm-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form style="width: 80%" ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="基地名称：" prop="farmId">
            <el-select style="width: 100%" size="small" v-model="itemParams.farmId" placeholder="请选择基地">
              <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="总亩数：" prop="measureTotal">
            <el-input-number size="small" v-model="itemParams.measureTotal" :min="1" label="描述文字"></el-input-number>
          </el-form-item>

          <el-form-item label="种植位置：" prop="areaTitleList">
            <div v-for="(item, index) in itemParams.areaTitleList" :key="index" style="width: 100%; display: flex">
              <el-input size="small" placeholder="请输入种植位置" v-model="itemParams.areaTitleList[index]"></el-input>
              <el-button type="text" v-if="index !== 0" @click="deleteAreaTitle(index)" class="mgl10">删除</el-button>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="text" @click="addAreaTitle">+增加</el-button>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveItem('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const areaTitleValidate = function (rule, value, callback) {
      let flag = true;
      for (let i = 0; i < value.length; i++) {
        if (value[i] === "") {
          flag = false;
        } else {
          flag = true;
        }
      }
      if (!flag) {
        callback(new Error("请输入种植位置"));
      } else {
        callback();
      }
    };
    return {
      listParams: {
        farmId: "",
      },
      baseNameList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      method: "",
      url: "",
      row: {},
      dialogTitle: "新增基地",
      dialogVisible: false,
      itemParams: {
        supplyId: "",
        farmId: "",
        measureTotal: 1,
        areaTitleList: [""],
      },
      checkItemParams: {
        farmId: [{ required: true, message: "请选择基地", trigger: "change" }],
        measureTotal: [{ required: true, message: "请输入总亩数", trigger: "change" }],
        areaTitleList: [{ required: true, validator: areaTitleValidate }],
      },
      isDisabled: false,
    };
  },
  mounted() {
    this.loadBaseNameList();
    this.loadTableData();
  },
  methods: {
    /**
     * 新增数据条目
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增生产数据维护";
      this.itemParams.areaTitleList = [""];
      this.method = "POST";
      this.url = global.apiUrl + "/farm/farm-production-preserve-insert";
      if (this.itemParams.areaId) {
        delete this.itemParams.areaId;
      }
    },
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-production-preserve-index",
        method: "GET",
        params: {
          farmId: this.listParams.farmId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 删除种植位置
     * @param index
     */
    deleteAreaTitle(index) {
      this.itemParams.areaTitleList.map((item, i) => {
        if (i === index) {
          this.itemParams.areaTitleList.splice(i, 1);
        }
      });
    },
    /**
     * 新增种植位置
     */
    addAreaTitle() {
      if (this.itemParams.areaTitleList.length >= 3) {
        this.$message.error("种植位置不能超过3个");
      } else {
        this.itemParams.areaTitleList.push("");
      }
    },
    /**
     * 保存新增或修改
     * @param name
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.itemParams.areaTitleList.length > 3) {
            this.$message.error("种植位置不能超过3个");
            this.isDisabled = false;
          } else {
            const itemParams = Object.assign({}, this.itemParams);
            if (this.method === "PUT") {
              const copyAreaTitleList = [];
              this.row.areaTitleList.map((item, index) => {
                this.itemParams.areaTitleList.map((item1, index1) => {
                  if (index === index1) {
                    copyAreaTitleList.push({
                      areaId: item.areaId,
                      areaTitle: this.itemParams.areaTitleList[index],
                    });
                  }
                });
              });
              itemParams.areaTitleList = copyAreaTitleList;
            }
            itemParams.supplyId = parseInt(this.$route.params.supplyId);
            this.$http({
              url: this.url,
              method: this.method,
              body: itemParams,
            })
              .then(res => {
                if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                  this.dialogVisible = false;
                  this.isDisabled = false;
                  this.$message.success(res.body.info);
                  this.loadTableData();
                } else {
                  this.isDisabled = false;
                }
              })
              .catch(err => {
                this.tableLoading = false;

                console.error(err);
              });
          }
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 编辑数据条目
     * @param row
     */
    editItem(row) {
      this.dialogVisible = true;
      this.dialogTitle = "编辑生产数据维护";
      this.method = "PUT";
      this.url = global.apiUrl + "/farm/farm-production-preserve-change";
      const itemParams = Object.assign({}, row);
      Object.assign(this.row, row);
      const areaTitleList = [];
      itemParams.areaTitleList.map(item => {
        areaTitleList.push(item.areaTitle);
      });
      itemParams.areaTitleList = areaTitleList;
      Object.assign(this.itemParams, itemParams);
    },
    /**
     * 删除条目数据
     * @param areaId
     */
    deleteItem(areaId) {
      this.$http({
        url: global.apiUrl + "/farm/farm-production-preserve-delete?areaId=" + areaId,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
